<template>
  <div style="margin-bottom: 40px">
    <div class="download-item download-item-bg-gq_pc_bg">
      <div class="download_item_imgs">
        <el-image
          class="download_show_img"
          v-for="(img, index) in sjList"
          :key="index"
          :src="img"
          :preview-src-list="sjList"
          >
        </el-image>
      </div>
      <div class="download-btn-content">
        <div class="download-btn-item">
          <a href="https://download.52bjd.com/pack/pc/52bjdmini/setup_52bjdmini.exe" @click="reportDot('gw_pc_gq_download')" class="download-btn-gf"></a>
          <span>推荐下载此版本</span>
        </div>
        <!-- <div class="download-btn-item">
          <a href="https://cdncfgh5.52bjd.com/pack/pc/52bjdmini/setup_52bjdmini.exe" @click="reportDot('gw_pc_mini_download')" class="download-btn-h5"></a>
          <span>如遇系统兼容问题请下载此版本</span>
        </div> -->
        <div class="download-btn-item">
          <a href="https://download.52bjd.com/pack/free/bjd-mini.zip" @click="reportDot('gw_pc_gq_free_download')" class="download-btn-maz"></a>
          <span>如遇安装失败问题可下载</span><br>
          <span>此版包体大，解压缩即玩</span>
        </div>
      </div>
    </div>
    <div class="old-pc-download-content">
      <div class="item-content">
        <div class="item-left-content">
          <p class="item-title">原PC端典藏版（2009版）</p>
        </div>
        <div class="item-right-content">
          <p><a href="https://dx.limsam.cn/down/bjdsetuphd.exe">安装包下载</a></p>
          <p><a href="https://download.52bjd.com/pack/free/bjd-old.zip">免安装硬盘版下载</a></p>
        </div>
      </div>
      <div class="item-content">
        <div class="item-left-content">
          <p class="item-title">原PC端高清版(2020版)</p>
        </div>
        <div class="item-right-content">
          <p><a href="https://download.52bjd.com/pack/pc/setup_52bjdpc_v4.0.1.2.exe">安装包下载</a></p>
          <p><a href="https://download.52bjd.com/pack/free/bjd-mini.zip">免安装硬盘版下载</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reportDotData } from '@/api/common'
export default {
  data () {
    return {
      pcList: [
        'https://cdncfgh5.52bjd.com/pc_website/images/download/pc_1.jpg',
        'https://cdncfgh5.52bjd.com/pc_website/images/download/pc_2.jpg',
        'https://cdncfgh5.52bjd.com/pc_website/images/download/pc_3.jpg',
        'https://cdncfgh5.52bjd.com/pc_website/images/download/pc_4.jpg'
      ],
      sjList: [
        'https://cdncfgh5.52bjd.com/pc_website/images/download/sj_1.jpg',
        'https://cdncfgh5.52bjd.com/pc_website/images/download/sj_2.jpg',
        'https://cdncfgh5.52bjd.com/pc_website/images/download/sj_3.jpg',
        'https://cdncfgh5.52bjd.com/pc_website/images/download/sj_4.jpg'
      ]
    }
  },
  methods: {
    reportDot (key) {
      let data = {}
      if (this.$store.state.userInfo.chrid) {
        console.log(this.$store.state.userInfo)
        data.chrid = this.$store.state.userInfo.chrid
      } else {
        data.chrid = 1
      }
      data.key = key
      data.params = '{"' + key + '":' + 1 + '}'
      reportDotData(data).then(res => {
        console.log(res)
      })
    }
  }
}
</script>

<style scoped>

.download-item {
  width: 100%;
  height: 433px;
  margin-bottom: 40px;
  position: relative;
  font-size: 18px;
  color: #999;
  background-color: #fff;
}

.download_item_imgs {
    position: absolute;
    width: 400px;
    bottom: 5px;
    left: 40px;
}

.download_item_imgs .download_show_img {
  display: inline-block;
  border: 2px solid hwb(55 49% 7%);
  width: 170px;
  height: 100px;
  margin: 5px;
}

.download-item-right-content {
  position: relative;
  width: 200px;
}

.download-item-bg-gq_pc_bg {
  background-image: url('~@/assets/image/download/new_resource/gq_pc_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.download-item-bg-dc_pc_bg {
  background-image: url('~@/assets/image/download/new_resource/dc_pc_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.download-btn-content {
  width: 250px;
  position: absolute;
  right: 100px;
  bottom: 80px;
  text-align: center;
  color: white;
  font-size: 16px;
}

.download-btn-item {
  margin-bottom: 25px;
}

.download-btn-gf {
  display: block;
  width: 100%;
  height: 80px;
  background-image: url('~@/assets/image/download/new_resource/gf_btn.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.download-btn-h5 {
  display: block;
  width: 100%;
  height: 60px;
  background-image: url('~@/assets/image/download/new_resource/h5_btn.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.download-btn-maz {
  display: block;
  width: 100%;
  height: 60px;
  background-image: url('~@/assets/image/download/new_resource/maz_btn.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.old-pc-download-content{
  margin-top: 200px;
}

.old-pc-download-content .item-content{
  display: inline-block;
  width: 49.8%;
  height: 120px;
  background-color: #d1d0d0;
  padding: 15px;
}

.old-pc-download-content .item-left-content{
  float:left;
  width: 60%;

}
.item-left-content p{
  color: #aaa3a3;
  font-size: 25px;
  font-weight: bold;
}

.old-pc-download-content .item-right-content{
  float:right;
  width: 30%;
  text-align: right;
  font-size: 10px;
  font-weight: bold;
  color: rgb(217, 222, 235);
}

.item-right-content p {
  margin-bottom: 5px;
}
.item-right-content a {
  padding-bottom: 10px;
  text-decoration:underline;
  color: #aaa3a3;
}
</style>



// WEBPACK FOOTER //
// src/views/download/children/Pc.vue